"use client";

import dynamic from "next/dynamic";

const ConvAI = dynamic(() => import("./ConvAI"));

export default ConvAI;
